import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";
export interface IFilterIconProps extends ISvgIconProps{
}

export class FilterIcon extends React.Component<IFilterIconProps, {}> {

    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 17 17" >
               <g fill="none">
                   <path d="M1.96987 3.27965C1.35497 3.0575 1 2.8016 1 2.52977C1 1.68427 4.35768 1 8.49999 1C12.6423 1 16 1.68427 16 2.52883C16 3.37339 12.6384 4.05766 8.49999 4.05766C6.96126 4.06764 5.5 4 3.90281 3.73708" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                   <path d="M1.00001 2.78394V4.30714C0.998888 4.65574 1.07539 5.00049 1.22433 5.31798C1.37327 5.63547 1.59116 5.91827 1.86319 6.14717L6.70284 10.1844C6.81162 10.2759 6.89875 10.389 6.95832 10.516C7.0179 10.6429 7.04852 10.7808 7.04811 10.9202V16.0007L9.95189 14.3134V10.9202C9.95148 10.7808 9.9821 10.6429 10.0417 10.516C10.1013 10.389 10.1884 10.2759 10.2972 10.1844L15.1368 6.14717C15.4088 5.91827 15.6267 5.63547 15.7757 5.31798C15.9246 5.00049 16.0011 4.65574 16 4.30714V2.78394" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
               </g>
           </SvgIcon>
        )
    }
}